export const FilespaceMenuTestIdFactory = {
    // Menu List Item Test Id
    getAccessAndPermissionsMenuItemTestId: () => 'filespace-access-and-permissions',
    getFilespaceSettingsMenuItemTestId: () => 'filespace-settings',
    getFilespaceConnectMenuItemTestId: () => 'filespace-connect',
    getFilespaceDisconnectMenuItemTestId: () => 'filespace-disconnect',
    getFilespaceOpenMenuItemTestId: () => 'filespace-open',
    getFilespaceDetailsMenuItemTestId: () => 'filespace-details',
    getFilespaceOpenInDesktopMenuItemTestId: () => 'open-in-desktop-app',
    getFilespaceUpgradeMenuItemTestId: () => 'upgrade-filespace',
    getFilespacePinnedFilesMenuItemTestId: () => 'pinned-files',
    getFilespaceLucidLinkConnectMenuItemTestId: () => 'lucidlink-connect',
    getFilespaceSnapshotsMenuItemTestId: () => 'snapshots',
    getFilespaceStopUpgradeMenuItemTestId: () => 'stop-upgrade',
    getFilespaceMigrationMenuItemTestId: () => 'migration',
    getDashboardMenuItemTestId: () => 'dashboard',
    getBrowserMenuItemTestId: () => 'browser',
    getFilespaceGuestLinksMenuItemTestId: () => 'guest-links',
};
